/**
 * Client Metrics Component
 * 
 * Displays key metrics and information about the selected client's assets
 */
import React, { useMemo } from 'react';

const ClientMetrics = ({ assets, clientName }) => {
  const metrics = useMemo(() => {
    if (!assets || assets.length === 0) {
      return {
        totalAssets: 0,
        criticalAssets: 0,
        lastUpdated: null
      };
    }
    
    // Calculate metrics
    const criticalAssets = assets.filter(asset => 
      asset.criticalityClassification?.includes('1-') || 
      asset.criticalityClassification?.includes('2-')
    ).length;
    
    // Find the most recently updated asset
    const lastUpdated = assets.reduce((latest, asset) => {
      if (!latest || (asset.lastUpdated && new Date(asset.lastUpdated) > new Date(latest))) {
        return asset.lastUpdated;
      }
      return latest;
    }, null);
    
    return {
      totalAssets: assets.length,
      criticalAssets,
      lastUpdated
    };
  }, [assets]);
  
  // Format date nicely
  const formatDate = (dateString) => {
    if (!dateString) return 'Never';
    
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  };
  
  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-md font-medium">Client Dashboard: {clientName}</h3>
      </div>
    </div>
  );
};

export default ClientMetrics; 